import React, { createContext, useContext, useEffect, useState } from "react";
import { t } from "../data/content";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("icon-lang") || "en");

  useEffect(() => {
    const dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);
    document.documentElement.setAttribute("lang", lang);
    localStorage.setItem("icon-lang", lang);
  }, [lang]);

  const toggle = () => setLang((p) => (p === "en" ? "ar" : "en"));
  const value = { lang, setLang, toggle, tr: t[lang], isAr: lang === "ar" };
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
